export default __webpack_public_path__ + "static/media/39-min.80c7f41e.jpg";